import { createSlice } from '@reduxjs/toolkit'

export const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        user: null, uid: null
    },
    tagTypes: ['User'],
    reducers: {
        setUser: (state, action) => ({
            ...state,
            user: action.payload
        }),
        setUid: (state, action) => ({
            ...state,
            uid: action.payload
        }),
    },
})

// Action creators are generated for each case reducer function
export const {
    setUser, setUid
} = userSlice.actions

export default userSlice.reducer